import mutations from "../importExport/mutations";
import getters from "../importExport/getters";
import { DataService, client } from "../../../config/dataService/dataService";

import { useMessage } from "../../../composables";
const { successMessage, errorMessage } = useMessage();
const state = () => ({
  loading: false,
  error: null,
  statusCode: false,
  currentUser: [],
  institutions: [],
  importHistory: [],
});

const actions = {
  async downloadExelFile(context, { url, ids, filters }) {
    try {
      const res = await client.post(`admin/${url}/download`,{ 
        filters,
        select: {
          ids
        }
       }, {responseType: 'blob' });
      successMessage("Exported Succesfully");
      return res.data;
    } catch (error) {
      errorMessage("Error on Export");
      console.error(error);
    }
  },
  async sendImportPool(context, file) {
    try {
      let res = await DataService.post(`admin/pool/`, file, {
        optionalHeader: {
          accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });

      return res;
    } catch (err) {
      return err;
    }
  },

  async sendImportPools(context, data) {
    try {
      let res = await DataService.post(`admin/pool/${data.type}`, data.file, {
        optionalHeader: {
          accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (err) {
      return err;
    }
  },

  async getImportRecords({ commit }, data) {
    try {
      let res = await DataService.get(
        `admin/records/?offset=${data.offset}&limit=${data.limit}`
      );
      commit("SET_IMPORT_RECORDS", res.data);

      return res?.data || [];
    } catch (err) {
      return err;
    }
  },


  
  async deleteImportRecord(context, data) {
    try {
      let res = await DataService.delete(`admin/records/${data}/`);

      if (res.status === 200) {
        successMessage("Succesfully deleted import.");
      }
      return res;
    } catch (err) {
      errorMessage("Something went wrong.");
      return err;
    }
  },
};

export default {
  namespaced: false,
  state,
  actions,
  mutations,
  getters,
};
